import { Card } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const TransferCurriculumPage = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()} title={t('curriculum.transferCurriculum')}>
      <Card>
        <div
          style={{
            fontSize: 'var(--font-size-xl',
            marginBottom: 'var(--spacing-6)',
          }}
        >
          {'Hier wird es künftig einen intuitiven Übernahme-Assisten geben.'}
        </div>
        <div>{'Bis zur Fertigstellung gehen Sie bitte wie folgt vor:'}</div>
        <ul>
          <li>
            {
              'Unter Deputate -> Einrichten -> Sollstunden klicken Sie auf den Button „Sollstunden“ bei der entsprechenden Sollstundentafel.'
            }
          </li>
          <li>{'Klicken Sie auf „Nach Jahrgängen“'}</li>
          <li>{'Wählen Sie einen Jahrgang'}</li>
          <li>{'Wählen Sie alle Einträge dieser Ansicht aus'}</li>
          <li>{'Klicken Sie auf „Aktion für Auswahl“ und wählen Sie in Schuljahr übernehmen'}</li>
          <li>
            {
              'In der letzten Spalte der Tabelle wird angezeigt wie viele Zuordnungen ins zu planenden Schuljahr übernommen wurden.'
            }
          </li>
          <li>{'Wiederholen Sie diesen Vorgang für alle Jahrgänge'}</li>
        </ul>
      </Card>
    </Page>
  );
};
